module.exports = __webpack_public_path__ + "img/rich-unchecked-ms.99034bc4.png";